import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getToDate } from "../../utils/utils";
import { fileUploadPath } from "../../utils/index";
import { getUserRole } from "../../utils/index";
import {
  faSearch,
  faPen,
  faTimes,
  faEye,
  faTrashAlt,
  faSyncAlt,
  faCalendarCheck,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field } from "formik";
import DataTable from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LeaseDetailsPopup from "../../viewLease/LeaseDetailsPopup";
import AmendLeaseView from "../../createLease/submitLease/AmendLeaseView";
import TerminateLease from "../submitLease/TerminateLease";
import MoreInfoComponent from "../submitLease/MoreInfoComponent";
import Dropdown from "react-bootstrap/Dropdown";
import moment from "moment";
function removeLease(leaseId, ths, status) {
  var del_message = "Are you sure you want to delete this draft lease.";

  if (status == 3) {
    del_message = "Are you sure you want to delete this expired lease.";
  }

  confirmAlert({
    title: "Confirm to delete",
    message: del_message,
    buttons: [
      {
        label: "Yes",
        onClick: () => {
          axios({
            method: "post",
            url: `${apiUrl.apiUrl.url}/create-lease/remove-lease`,
            data: { leaseId: leaseId },
          }).then(function (response) {
            ths.resetCounter();
            ths.loadLeaseCountStatuswise();
          });
        },
      },
      {
        label: "No",
        onClick: () => {
          console.log("cancel clicked");
        },
      },
    ],
  });
}

var counter = Math.round();

function DeleteBtn(props) {
  return (
    (props.status == 0 || props.status == 3) &&
    (props.status == 0 ? (
      <>
        {/* <span
          className="tableActionnewDelete"
          onClick={() => removeLease(props.leaseId, props.ths)}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </span>
        <span
          onClick={() => removeLease(props.leaseId, props.ths, props.status)}
        >
          {" "}
          Delete
        </span> */}
        <div className="dropDownTagWIthIcon" onClick={() => removeLease(props.leaseId, props.ths)}>
          <span
            className="tableActionnewDelete ta">
            <FontAwesomeIcon icon={faTrashAlt} /> Delete
          </span>
        </div>

      </>
    ) : (
      <>
        {/* <span
          className="tableActionnewDelete"
          onClick={() => removeLease(props.leaseId, props.ths)}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </span>
        <span
          onClick={() => removeLease(props.leaseId, props.ths, props.status)}
        >
          {" "}
          F&F
        </span> */}
        <div className="dropDownTagWIthIcon" onClick={() => removeLease(props.leaseId, props.ths)}>
          <span
            className="tableActionnewDelete ta">
            <FontAwesomeIcon icon={faTrashAlt} /> F&F
          </span>
        </div>
      </>
    ))
  );
}

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>

    

  </>
);

const LeaseListingTable = ({ asset, brand, status, marque, dispute, ths }) => {
  //console.log(asset);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [leaseId, setLeaseId] = useState(0);
  const [costCenter, setCostCenter] = useState(0);
  const [desputeStatus, setDesputeStatus] = useState(0);
  const [marqueStatus, setMarqueStatus] = useState(0);
  const [popupKey, setpopupKey] = useState(0);
  //const [currState, ]

  React.useEffect(() => {
    fetchUsers(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchUsers = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/lease-view/get-all-leases?asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}&status=${status}&marque=${marque}&dispute=${dispute}`
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUsers(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/lease-view/get-all-leases?asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1&status=${status}&marque=${marque}&dispute=${dispute}`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openFromParent() {
    setIsOpen(true);
  }

  function handleCloseModal() {
    setIsOpen(false);
  }

  const [checked, setChecked] = useState(false);

  const [show, setShow] = useState(false);
  const [disput_show, setDisputShow] = useState(false);
  const [renewShow, setRenewalShow] = useState(false);
  const [extendShow, setExtendShow] = useState(false);
  const [terminateShow, setTerminateShow] = useState(false);

  const [amendMenus, setAmendMenus] = useState([]);
  const [renewList, setRenewalList] = useState([]);
  const [extendList, setExtendList] = useState([]);
  // const [leaseId, setLeaseId] = useState(0);
  const [leaseCode, setLeaseCode] = useState(0);
  const [costCenterNo, setcostCenterNo] = useState(0);
  const [selectedFile, setSelectedFile] = useState({});

  const [leaseTerminationOption, setLeaseTerminationOption] = useState([
    "ABCD",
    "asd",
  ]);

  const [termYear, setTermYear] = useState(0);
  const [termMonth, setTermMonth] = useState(0);
  const [termDay, setTermDay] = useState(0);

  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [commertials, setCommersials] = useState("");

  const [unit_status, setUnitStatus] = useState("");
  const [remarks, setRemarks] = useState("");
  const [termination_settlement, setTerminationSettlement] = useState("");
  const [leaseTerminationOptionVal, setLeaseTerminationOptionVal] =
    useState("");

  const [popupalertMessage, setpopupalertMessage] = useState(false);
  const [popupMessageContent, setpopupMessageContent] = useState("");

  const [formSubmitted, setFormSubmitted] = useState(false);

  //const [onUploadError , setonUploadError]=useState();
  //const [onUploadFinish , setonUploadFinish]=useState();

  const onUploadError = () => {
    // this.setState({ messsagePopup: true ,
    //   popupContent: "Something Went Wrong!"
    // });
    setpopupMessageContent("Something Went Wrong");
    setpopupalertMessage(true);

    // alert("Something Went Wrong");
  };
  const onUploadFinish = (e) => {
    var values = {
      leaseDocument: {
        leaseDocumentType: "Amend Document",
        leaseUploadDocumentDate: "2020-05-11",
        leaseDocumentUrl: fileUploadPath() + leaseId + "/ac.pdf",
      },
    };
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    console.log(isChecked, "isChecked")
    // Define the value to be sent in the request
    const value = isChecked ? 1 : 0;
    ths.resetCounter();
  }  

  const showTerminateBox = (id) => {
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/fetch-lease-details?leaseId=${id}`,
      data: { leaseId: id },
    }).then(function (response) {
      setLeaseId(id);
      setLeaseCode(response.data.data.lease_code);
      setcostCenterNo(response.data.cost_center);
      setTerminateShow(true);
      setFormSubmitted(false);
    });
  };
  // -----------------------------------------------
  const showExtendlBox = (id) => {
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/fetch-extend-option?leaseId=${id}`,
      //url: `${apiUrl.apiUrl.url}/lease-view/fetch-extend-option?costCenter=${costCenter}`,
      data: { leaseId: id },
    }).then(function (response) {
      setExtendList(response.data.data);
      setLeaseId(id);
      setStartDate(moment(response.data.data[0].renewal_start).format("DD-MMM-YYYY"));
      setCommersials(response.data.data[0].commersials);
      setLeaseCode(response.data.leaseDetails.lease_code);
      setcostCenterNo(response.data.leaseDetails.cost_center);
      setExtendShow(true);
      setFormSubmitted(false);
    });
  };

  const showRenewalBox = (id) => {
    // axios({
    //   method: "post",
    //   url: `${apiUrl.apiUrl.url}/lease-view/fetch-renew-option?leaseId=${id}`,
    //   data: { leaseId: id },
    // }).then(function (response) {
    //   setRenewalList(response.data.data);
    //   setLeaseId(id);
    //   setLeaseCode(response.data.leaseDetails.lease_code);
    //   setCostCenter(response.data.leaseDetails.cost_center);
    //   setRenewalShow(true);
    // });
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/fetch-extend-option?leaseId=${id}`,
      //url: `${apiUrl.apiUrl.url}/lease-view/fetch-extend-option?costCenter=${costCenter}`,
      data: { leaseId: id },
    }).then(function (response) {
      setExtendList(response.data.data);
      setLeaseId(id);
      setStartDate(moment(response.data.data[0].renewal_start).format("DD-MMM-YYYY"));
      setCommersials(response.data.data[0].commersials);
      setLeaseCode(response.data.leaseDetails.lease_code);
      setcostCenterNo(response.data.leaseDetails.cost_center);
      setRenewalShow(true);
      setFormSubmitted(false);
    });
  };

  //const handleRenewClose =
  const handleRenewClose = () => setRenewalShow(false);
  const handleExtendClose = () => setExtendShow(false);
  const handleTerminateClose = () => setTerminateShow(false);

  

  const disputShow = (id) => {
    console.log("mer log");
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/lease-view/lease-details-view?leaseId=${id}`
      //data: { leaseId: id },
    }).then(function (response) {
      setLeaseCode(response.data.data.lease_code);
      setCostCenter(response.data.data.cost_center);
      setDesputeStatus(response.data.data.additionalDetails.dispute_status);
      setMarqueStatus(response.data.data.additionalDetails.marque_status)
      setLeaseId(id);
      setDisputShow(true);
    });
  };
  

  const handleShow = (id) => {
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/fetch-amend-option?leaseId=${id}`,
      data: { leaseId: id },
    }).then(function (response) {
      setAmendMenus(response.data.data);
      setLeaseCode(response.data.leaseDetails.lease_code);
      setCostCenter(response.data.leaseDetails.cost_center);

      setLeaseId(id);
      setShow(true);
      setFormSubmitted(false);
    });
  };

  const calculateStarEndDate = (day, month, year) => {
    let date = moment(getToDate(start_date, Number(day), Number(month), Number(year))).format("DD-MMM-YYYY");

    setEndDate(date);
  };

  const onFileChange = (event) => {
    // Update the state
    setSelectedFile(event.target.files[0]);
  };

  const redirectToClose = () => {
    setpopupMessageContent("");
    setpopupalertMessage(false);
  };
  // On file upload (click the upload button)
  const onFileUpload = (values, ths) => {
    // Create an object of formData
    const formData = new FormData();

    if (
      typeof selectedFile == "undefined" ||
      typeof selectedFile.name == "undefined"
    ) {
      setpopupMessageContent("Please upload file to process");
      setpopupalertMessage(true);
      // alert("Please upload file to process");
      //setpopupMessageContent('Please upload file to process');
      //setpopupalertMessage(true);
      return true;
    }
    //var ths = this;

    // Update the formData object
    formData.append("myFile", selectedFile, selectedFile.name);
    formData.append("unit_status", values.change_unit_staus);
    formData.append("remarks", values.remarks);
    formData.append("termination_settlement", values.termination_settlement);
    formData.append("termination_type", values.termination_type);
    formData.append("effective_date", values.effectiveDate);
    // Request made to the backend api
    // Send formData object
    axios
      .post(
        `${apiUrl.apiUrl.url}/lease-view/terminate-lease?leaseId=${leaseId}`,
        formData
      )
      .then(function (response) {
        console.log(response, "response");
        if (response.data.success) {
          // alert("Form processed successfully.");
          setpopupMessageContent("Form processed successfully.");
          setpopupalertMessage(true);
          setTerminateShow(false);
          if (typeof response.data.link == "undefined") {
            ths.resetCounter();
            ths.loadLeaseCountStatuswise();
            setpopupalertMessage(false);
          }

          setTimeout(function () {
            setpopupalertMessage(false);
            ths.props.history.push(response.data.link);
          }, 2000);
        } else {
          // alert("Something went wrong.");
          setpopupMessageContent("Something went wrong.");
          setpopupalertMessage(true);
          setTerminateShow(false);
          ths.resetCounter();
          ths.loadLeaseCountStatuswise();
        }
      });
  };

  const handleClose = () => setShow(false);
  const handleDisputClose = () => setDisputShow(false);
  const columns = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      grow: 1,
    },
    {
      name: "Lease Id",
      selector: "leaseCode",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Cost Center",
      selector: "cost_center",
      sortable: false,
      grow: 3,
      wrap: true,
    },

    {
      name: "Asset Name",
      selector: "assetName",
      sortable: false,
      grow: 3,
      wrap: true,
      style: {
        textAlign: "center",
      },
    },
    {
      name: "Unit Number",
      selector: "unit_no",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "GLA (Sq.Ft.)",
      selector: "gross_leasable_area",
      sortable: false,
      grow: 1,
      wrap: true,
    },
    {
      name: "Brand Name / Occupier Name",
      selector: "brandName",
      sortable: false,
      grow: 3,
      wrap: true,
      style: {
        textAlign: "center",
      },
    },
    {
      name: "Lease Commencement Date",
      selector: "lcd",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: " Lease Term (YY-MM-DD)",
      selector: "leaseTerm",
      sortable: false,
      grow: 2,
    },
    {
      name: "Lease Expiry Date",
      selector: "leaseExpiryData",
      sortable: false,
      grow: 2,
      wrap: true,
    },
    {
      name: "Action",
      grow: 3,
      // selector: "info",
      sortable: false,
      cell: (record) => {
        if (record.status == 2) {
          return (
            <Dropdown>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className="btnActions"
              >
                Action
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropup">
                {record.status == 2 && getUserRole() == "admin" && (
                  <Dropdown.Item>
                    {/* <span className="tableActionnewView"> */}
                    <Link
                      to={`/lease-summary/view-lease/lease-details/${record.leaseId}`}
                    >
                      <FontAwesomeIcon icon={faEye} /> View Lease
                    </Link>
                    {/* </span> */}
                    {/* <span>
                      <Link
                        to={`/lease-summary/view-lease/lease-details/${record.leaseId}`}
                        style={{ color: "#000", textDecoration: "none" }}
                      >
                        
                      </Link>
                    </span> */}
                  </Dropdown.Item>
                )}
                {record.status == 2 &&
                  getUserRole() == "admin" &&
                  record.editable && (
                    <Dropdown.Item>
                      {/* <span className="tableActionnewEdit"> */}
                      <Link
                        to={`/createlease/lease-landlord/${record.leaseId}`}
                      >
                        <FontAwesomeIcon icon={faPen} /> Edit Lease
                      </Link>
                      {/* </span> */}
                      {/* <span>
                        <Link
                          to={`/createlease/lease-landlord/${record.leaseId}`}
                          style={{ color: "#000", textDecoration: "none" }}
                        >
                          Edit Lease
                        </Link>
                      </span> */}
                    </Dropdown.Item>
                  )}
                <Dropdown.Item onClick={() => handleShow(record.leaseId)}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Amend"
                      onClick={() => handleShow(record.leaseId)}
                      className="tableActionnewAmend ta"
                    >
                      <FontAwesomeIcon icon={faPen} /> Amend Lease
                    </span>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => showExtendlBox(record.leaseId)}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Extend"
                      onClick={() => showExtendlBox(record.leaseId)}
                      className="tableActionnewEdit"
                    >
                      {" "}
                      <FontAwesomeIcon icon={faCalendarCheck} /> Extend Lease
                    </span>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => showRenewalBox(record.leaseId)}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Renew"
                      onClick={() => showRenewalBox(record.leaseId)}
                      className="tableActionnewRenew ta"
                    >
                      <FontAwesomeIcon icon={faSyncAlt} /> Renew Lease
                    </span>
                  </div>
                </Dropdown.Item>

                <Dropdown.Item onClick={() => showTerminateBox(record.leaseId)}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Terminate"
                      onClick={() => showTerminateBox(record.leaseId)}
                      className="tableActionnewDelete ta"
                    >
                      <FontAwesomeIcon icon={faTimes} /> Terminate Lease
                    </span>
                  </div>
                </Dropdown.Item>

                <Dropdown.Item onClick={(e) => {
                  setLeaseId(record.leaseId);
                  setpopupKey(Math.random());
                  openFromParent();
                }}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Info"
                      onClick={(e) => {
                        setLeaseId(record.leaseId);
                        setpopupKey(Math.random());
                        openFromParent();
                      }}
                      className="tableActionnewAmend ta"
                    >
                      <FontAwesomeIcon icon={faInfoCircle} /> Lease Info
                    </span>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={`/createlease/waiver/${record.leaseId}`}>
                    {" "}
                    <FontAwesomeIcon icon={faPen} /> Waiver
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item onClick={(e) => {
                  // setLeaseId(record.leaseId);
                  // setpopupKey(Math.random());
                  // openFromParent();
                }}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Info"
                      onClick={(e) => {
                        setLeaseId(record.leaseId);
                        disputShow(record.leaseId)
                      }}
                      className="tableActionnewAmend ta"
                    >
                      <FontAwesomeIcon icon={faInfoCircle} /> More
                    </span>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        } else if (record.status == 4 || record.status == 8) {
          return "-";
        } else if (record.status == 3) {
          return (
            <>
              {
                <Dropdown>
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    className="btnActions"
                  >
                    Action
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropup">
                    <Dropdown.Item>
                      <DeleteBtn
                        status={record.status}
                        leaseId={record.leaseId}
                        ths={ths}
                      ></DeleteBtn>
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => showExtendlBox(record.leaseId)}>
                      <div className="dropDownTagWIthIcon">
                        <span
                          title="Extend"
                          onClick={() => showExtendlBox(record.leaseId)}
                          className="tableActionnewEdit ta"
                        >
                          <FontAwesomeIcon icon={faCalendarCheck} /> Extend Lease
                        </span>
                      </div>
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => showRenewalBox(record.leaseId)}>
                      <div className="dropDownTagWIthIcon">
                        <span
                          title="Renew"
                          onClick={() => showRenewalBox(record.leaseId)}
                          className="tableActionnewRenew ta"
                        >
                          <FontAwesomeIcon icon={faSyncAlt} /> Renew Lease
                        </span>
                      </div>
                    </Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>
              }
            </>
          );
        } else {
          return (
            <>
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  className="btnActions"
                >
                  Action
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropup">
                  {(record.type == "original" ||
                    record.type == "lease_copying" ||
                    record.type == "") &&
                    (record.status == 0 ||
                      (record.status == 1 && (getUserRole() == "admin" || getUserRole() == "checker")) ||
                      record.status == 3) &&
                    (getUserRole() == "admin" || getUserRole() == "maker") && (
                      <Dropdown.Item>
                        {/* <span className="tableActionnewEdit"> */}
                        <Link
                          to={`/createlease/lease-landlord/${record.leaseId}`}
                        >
                          {" "}
                          <FontAwesomeIcon icon={faPen} /> {record.status == 0 ? 'Edit Lease' : 'Approve Lease'}
                        </Link>
                        {/* </span> */}
                        {/* <Link
                          to={`/createlease/lease-landlord/${record.leaseId}`}
                        >
                          {
                            record.status == 0 ? 'Edit Lease' : 'Approve Lease'
                          }
                        </Link> */}
                      </Dropdown.Item>
                    )}
                  {record.type == "amend" && (
                    <Dropdown.Item>
                      {/* <span className="tableActionnewEdit"> */}
                      <Link
                        to={`/amendlease/lease-landlord/${record.leaseId}`}
                      >
                        {" "}
                        <FontAwesomeIcon icon={faPen} /> {
                          record.status == 0 ? 'Edit Lease' : 'Approve Lease'
                        }
                      </Link>
                      {/* </span> */}
                      {/* <Link to={`/amendlease/lease-landlord/${record.leaseId}`}>
                        
                      </Link> */}
                    </Dropdown.Item>
                  )}
                  {record.type == "renew" && (
                    <Dropdown.Item>
                      <Link to={`/renewlease/lease-landlord/${record.leaseId}`}>
                        {/* <span className="tableActionnewRenew"> */}
                        <FontAwesomeIcon icon={faPen} /> {
                          record.status == 0 ? 'Edit Lease' : 'Approve Lease'
                        }
                        {/* </span> */}
                      </Link>
                      {/* <Link to={`/renewlease/lease-landlord/${record.leaseId}`}>

                      </Link> */}
                    </Dropdown.Item>
                  )}
                  {record.type == "extend" && (
                    <Dropdown.Item>
                      <Link
                        to={`/extendlease/lease-landlord/${record.leaseId}`}
                      >
                        {/* <span className="tableActionnewRenew"> */}
                        <FontAwesomeIcon icon={faPen} /> {
                          record.status == 0 ? 'Edit Lease' : 'Approve Lease'
                        }
                        {/* </span> */}
                      </Link>
                      {/* <Link
                        to={`/extendlease/lease-landlord/${record.leaseId}`}
                      >

                      </Link> */}
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item onClick={(e) => {
                  // setLeaseId(record.leaseId);
                  // setpopupKey(Math.random());
                  // openFromParent();
                }}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Info"
                      onClick={(e) => {
                        setLeaseId(record.leaseId);
                        disputShow(record.leaseId)
                      }}
                      className="tableActionnewAmend ta"
                    >
                      <FontAwesomeIcon icon={faInfoCircle} /> More
                    </span>
                  </div>
                </Dropdown.Item>  
                  <Dropdown.Item>
                    <DeleteBtn
                      status={record.status}
                      leaseId={record.leaseId}
                      ths={ths}
                    ></DeleteBtn>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          );
        }
      },
    },
  ];
  return (
    <div className="parentContainer">
      <div className="tableContainer theFixedTableClass position-relative">
        <DataTable

          columns={columns}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={terminateShow}
              size="lg"
              className="terminationFade"
              onHide={handleTerminateClose}
            >
              <Modal.Header closeButton>
                <Modal.Title>Lease Termination</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <TerminateLease
                  leaseCode={leaseCode}
                  costCenter={costCenter}
                  leaseId={leaseId}
                  setShow={setTerminateShow}
                  setpopupMessageContent={setpopupMessageContent}
                  setpopupalertMessage={setpopupalertMessage}
                  ths={ths}
                />
              </Modal.Body>
            </Modal>

            <Modal show={extendShow} size="xl" onHide={handleExtendClose}>
              <Modal.Header closeButton>
                <Modal.Title>Lease Extend</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Formik
                  initialValues={{}}
                  enableReinitialize
                  onSubmit={(values, actions) => {
                    console.log(values, "valuee....");
                    var self = this;
                    if(! formSubmitted) {
                      setFormSubmitted(true);
                      axios({
                        method: "post",
                        url: `${apiUrl.apiUrl.url}/lease-view/extend-lease?leaseId=${leaseId}`,
                        data: values,
                      }).then(function (response) {
                        setFormSubmitted(false);
                        if (!response.data.success) {
                          // alert("Something went wrong!!");
                          setpopupMessageContent("Something went wrong.");
                          setpopupalertMessage(true);
                        } else {
                          // alert("Details Stored successfully.");
                          setpopupMessageContent("Details Stored successfully.");
                          setpopupalertMessage(true);
                          setTimeout(function () {
                            ths.props.history.push(response.data.link);
                          }, 1000);
                        }
                      });
                    }
                  }}
                >
                  {({
                    values,

                    errors,

                    touched,

                    handleChange,

                    handleBlur,

                    handleSubmit,

                    isSubmitting,
                    resetForm,
                  }) => (
                    <Form autoComplete="off" className="customTabs">
                      <div className="unitFormContainer amend">
                        <div className="container-fluid p-0">
                          <div className="row prospectAccordion">
                            <div className="col-lg-6 offset-lg-3">
                              <div className="tableContainer prospectTable mt-0">
                                <table className="table">
                                  <tbody>
                                    <tr>
                                      <th
                                        scope="col"
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                          borderRight: "1px solid #fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Lease No
                                      </th>

                                      <td
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                        }}
                                      >
                                        {leaseCode}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th
                                        scope="col"
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                          borderRight: "1px solid #fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Cost Center
                                      </th>

                                      <td
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                        }}
                                      >
                                        {costCenterNo}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="inputContainer"></div>
                            </div>
                            <div className="col-lg-12">
                              <div className="tableContainer screens">
                                <table className="table tableSimple tableSimpleWithNoFlex">
                                  <thead>
                                    <tr>
                                      <th>Lease Term in Lease</th>
                                      <th>term</th>
                                      <th>From</th>
                                      <th>To</th>
                                      <th>Commercials</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {extendList.length > 0 &&
                                      extendList.map((pageItem, obj) => (
                                        <tr>
                                          <td>{pageItem.title}</td>
                                          <td>{pageItem.term}</td>
                                          <td>{pageItem.from}</td>
                                          <td>{pageItem.to}</td>
                                          <td>{pageItem.commersials}</td>
                                          <td>
                                            {pageItem.isActive && (
                                              <Field
                                                type="checkbox"
                                                name={`option`}
                                                value={`${pageItem.from}==${pageItem.to}`}
                                                className="sameAs"
                                              />
                                            )}
                                            {!pageItem.isActive && "NA"}
                                          </td>
                                        </tr>
                                      ))}

                                    <tr>
                                      <td>Extend Term 1 (YY-MM-DD)</td>
                                      <td>
                                        <div className="row m-0">
                                          <div class="col-sm-3 p-0">
                                            <Field
                                              type="text"
                                              class="centerPlaceHolder w-100"
                                              name="year"
                                              placeholder="YY"
                                              onChange={(e) => {
                                                setTermYear(e.target.value);
                                                calculateStarEndDate(
                                                  termDay,
                                                  termMonth,
                                                  e.target.value
                                                );
                                                handleChange(e);
                                              }}
                                            />
                                          </div>
                                          <div class="col-sm-3 p-0 mx-2">
                                            <Field
                                              type="text"
                                              class="centerPlaceHolder w-100"
                                              name="month"
                                              placeholder="MM"
                                              onChange={(e) => {
                                                setTermMonth(e.target.value);
                                                //calculateStarEndDate(e, values);
                                                calculateStarEndDate(
                                                  termDay,
                                                  e.target.value,
                                                  termYear
                                                );
                                                handleChange(e);
                                              }}
                                            />
                                          </div>
                                          <div class="col-sm-3 p-0">
                                            <Field
                                              type="text"
                                              class="centerPlaceHolder w-100"
                                              name="day"
                                              placeholder="DD"
                                              onChange={(e) => {
                                                setTermDay(e.target.value);
                                                calculateStarEndDate(e, values);
                                                calculateStarEndDate(
                                                  e.target.value,
                                                  termMonth,
                                                  termYear
                                                );
                                                handleChange(e);
                                              }}
                                            />

                                            <Field
                                              type="hidden"
                                              className="w-100"
                                              value={start_date}
                                              name="start_date"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            <Field
                                              type="hidden"
                                              className="w-100"
                                              value={end_date}
                                              name="end_date"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </td>
                                      <td>{start_date}</td>
                                      <td>{end_date}</td>
                                      <td>{commertials}</td>
                                      <td>
                                        {end_date != "" && (
                                          <></>
                                          // <Field
                                          //   type="checkbox"
                                          //   name={`option`}
                                          //   //value={`${pageItem.from}==${pageItem.to}`}
                                          //   className="sameAs"
                                          // />
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div class="col-lg-12 p-0">
                              <Modal.Footer className="button_group d-flex align-items-center gap-2 justify-content-end">
                                <button className="add_button" type="submit">
                                  Extend
                                </button>
                              </Modal.Footer>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>

            <Modal size="lg" show={renewShow} onHide={handleRenewClose}>
              <Modal.Header closeButton>
                <Modal.Title>Lease Renewal</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Formik
                  initialValues={{}}
                  enableReinitialize
                  onSubmit={(values, actions) => {
                    console.log(values, "valuee....");
                    var self = this;

                    if(! formSubmitted) {
                      setFormSubmitted(true);
                      axios({
                        method: "post",
                        url: `${apiUrl.apiUrl.url}/lease-view/renew-lease?leaseId=${leaseId}`,
                        data: values,
                      }).then(function (response) {
                        setFormSubmitted(true);
                        if (!response.data.success) {
                          // alert("Something went wrong!!");
                          setpopupMessageContent("Something went wrong.");
                          setpopupalertMessage(true);
                        } else {
                          // alert("Details Stored successfully.");
                          setpopupMessageContent("Details Stored successfully.");
                          setpopupalertMessage(true);
                          setTimeout(function () {
                            ths.props.history.push(response.data.link);
                          }, 1000);
                        }
                      });
                    }

                    

                    
                  }}
                >
                  {({
                    values,

                    errors,

                    touched,

                    handleChange,

                    handleBlur,

                    handleSubmit,

                    isSubmitting,
                    resetForm,
                  }) => (
                    <Form autoComplete="off" className="customTabs">
                      <div className="unitFormContainer amend">
                        <div className="container-fluid p-0">
                          <div className="row prospectAccordion">
                            <div className="col-lg-6 offset-lg-3">
                              <div className="tableContainer prospectTable mt-0">
                                <table className="table">
                                  <tbody>
                                    <tr>
                                      <th
                                        scope="col"
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                          borderRight: "1px solid #fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Lease No
                                      </th>

                                      <td
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                        }}
                                      >
                                        {leaseCode}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th
                                        scope="col"
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                          borderRight: "1px solid #fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Cost Center
                                      </th>

                                      <td
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                        }}
                                      >
                                        {costCenterNo}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="inputContainer"></div>
                            </div>
                            <div className="col-lg-12">
                              <div className="tableContainer screens">
                                <table className="table tableSimple tableSimpleWithNoFlex">
                                  <thead>
                                    <tr>
                                      <th>Lease Term in Lease</th>
                                      <th>Term</th>
                                      <th>From</th>
                                      <th>To</th>
                                      {/* <th>Commercials</th>
                                      <th>Status</th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {extendList.length > 0 &&
                                      extendList.map((pageItem, obj) => (
                                        <tr>
                                          <td>{pageItem.title}</td>
                                          <td>{pageItem.term}</td>
                                          <td>{pageItem.from}</td>
                                          <td>{pageItem.to}</td>
                                          {/* <td>{pageItem.commersials}</td> */}
                                          {/* <td>
                                            {pageItem.isActive && (
                                              <Field
                                                type="checkbox"
                                                name={`option`}
                                                value={`${pageItem.from}==${pageItem.to}`}
                                                className="sameAs"
                                              />
                                            )}
                                            {!pageItem.isActive && "NA"}
                                          </td> */}
                                        </tr>
                                      ))}

                                    <tr>
                                      <td>Renew Term (YY-MM-DD)</td>
                                      <td>
                                        <div className="row m-0">
                                          <div class="col-sm-3 p-0">
                                            <Field
                                              type="text"
                                              class="centerPlaceHolder w-100"
                                              name="year"
                                              placeholder="YY"
                                              onChange={(e) => {
                                                setTermYear(e.target.value);
                                                calculateStarEndDate(
                                                  termDay,
                                                  termMonth,
                                                  e.target.value
                                                );
                                                handleChange(e);
                                              }}
                                            />
                                          </div>
                                          <div class="col-sm-3 p-0 mx-2">
                                            <Field
                                              type="text"
                                              class="centerPlaceHolder w-100"
                                              name="month"
                                              placeholder="MM"
                                              onChange={(e) => {
                                                setTermMonth(e.target.value);
                                                //calculateStarEndDate(e, values);
                                                calculateStarEndDate(
                                                  termDay,
                                                  e.target.value,
                                                  termYear
                                                );
                                                handleChange(e);
                                              }}
                                            />
                                          </div>
                                          <div class="col-sm-3 p-0">
                                            <Field
                                              type="text"
                                              class="centerPlaceHolder w-100"
                                              name="day"
                                              placeholder="DD"
                                              onChange={(e) => {
                                                setTermDay(e.target.value);
                                                calculateStarEndDate(e, values);
                                                calculateStarEndDate(
                                                  e.target.value,
                                                  termMonth,
                                                  termYear
                                                );
                                                handleChange(e);
                                              }}
                                            />

                                            <Field
                                              type="hidden"
                                              className="w-100"
                                              value={start_date}
                                              name="start_date"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            <Field
                                              type="hidden"
                                              className="w-100"
                                              value={end_date}
                                              name="end_date"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </td>
                                      <td>{start_date}</td>
                                      <td>{end_date}</td>
                                      {/* <td>{commertials}</td> */}
                                      {/* <td>
                                        {end_date != "" && (
                                          <></>
                                          // <Field
                                          //   type="checkbox"
                                          //   name={`option`}
                                          //   //value={`${pageItem.from}==${pageItem.to}`}
                                          //   className="sameAs"
                                          // />
                                        )}
                                      </td> */}
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div class="col-lg-12 p-0">
                              <Modal.Footer className="button_group d-flex align-items-center gap-2 justify-content-end">
                                <button className="add_button" type="submit">
                                  Renew
                                </button>
                              </Modal.Footer>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>

            <Modal size="lg" >
            {/* show={renewShow} onHide={handleRenewClose} */}
              <Modal.Header closeButton>
                <Modal.Title>Lease Renewal</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Formik
                  initialValues={{}}
                  //enableReinitialize
                  onSubmit={(values, actions) => {
                    console.log(values, "valuee....");
                    var self = this;
                    if(! formSubmitted) {
                      setFormSubmitted(true);
                      axios({
                        method: "post",
                        url: `${apiUrl.apiUrl.url}/lease-view/renew-lease?leaseId=${leaseId}`,
                        data: { checkedItems: values.option },
                      }).then(function (response) {
                        setFormSubmitted(false);
                        if (!response.data.success) {
                          // alert("Something went wrong!!");
                          setpopupMessageContent("Something went wrong.");
                          setpopupalertMessage(true);
                        } else {
                          // alert("Details Stored successfully.");
                          setpopupMessageContent("Details Stored successfully.");
                          setpopupalertMessage(true);
                          setTimeout(function () {
                            ths.props.history.push(response.data.link);
                          }, 1000);
                        }
                      });
                    }
                  }}
                >
                  {({
                    values,

                    errors,

                    touched,

                    handleChange,

                    handleBlur,

                    handleSubmit,

                    isSubmitting,
                    resetForm,
                  }) => (
                    <Form autoComplete="off" className="customTabs">
                      <div className="unitFormContainer amend">
                        <div className="container-fluid p-0">
                          <div className="row prospectAccordion">
                            <div className="col-lg-6 offset-lg-3">
                              <div className="tableContainer prospectTable mt-0">
                                <table className="table">
                                  <tbody>
                                    <tr>
                                      <th
                                        scope="col"
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                          borderRight: "1px solid #fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Lease No
                                      </th>
                                      <td
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                        }}
                                      >
                                        {leaseCode}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th
                                        scope="col"
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                          borderRight: "1px solid #fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Cost center
                                      </th>
                                      <td
                                        style={{
                                          backgroundColor: "#005b9b",
                                          color: "#fff",
                                        }}
                                      >
                                        {costCenter}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="inputContainer"></div>
                            </div>
                            <div className="col-lg-12">
                              <div className="tableContainer screens">
                                <table className="table tableSimple">
                                  <thead>
                                    <tr>
                                      <th>Lease Term in Lease</th>
                                      <th>term</th>
                                      <th>From</th>
                                      <th>To</th>
                                      <th>Commercials</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {renewList.length > 0 &&
                                      renewList.map((pageItem, obj) => (
                                        <tr>
                                          <td>{pageItem.title}</td>
                                          <td>{pageItem.term}</td>
                                          <td>{pageItem.from}</td>
                                          <td>{pageItem.to}</td>
                                          <td>{pageItem.commersials}</td>
                                          <td>
                                            {pageItem.isActive && (
                                              <Field
                                                type="checkbox"
                                                name={`option`}
                                                value={`${pageItem.from}==${pageItem.to}`}
                                                className="sameAs"
                                              />
                                            )}
                                            {!pageItem.isActive && "NA"}
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {renewList.length > 1 && (
                              <div class="col-lg-12 text-center">
                                <Modal.Footer className="justify-content-center">
                                  <button variant="secondary" type="submit">
                                    <FontAwesomeIcon icon={faSyncAlt} /> Renew
                                  </button>
                                </Modal.Footer>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>

            <Modal
              show={show}
              onHide={handleClose}
              size="xl"
              className="documentModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Lease Amend
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <AmendLeaseView
                  amendMenus={amendMenus}
                  leaseCode={leaseCode}
                  leaseId={leaseId}
                  costCenter={costCenter}
                  setShow={setShow}
                  setpopupMessageContent={setpopupMessageContent}
                  setpopupalertMessage={setpopupalertMessage}
                  setFormSubmitted={setFormSubmitted}
                  formSubmitted={formSubmitted}
                />
              </Modal.Body>
            </Modal>

            <Modal
              show={disput_show}
              onHide={handleDisputClose}
              size="xl"
              className="documentModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Lease Details
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <MoreInfoComponent 
                  leaseCode={leaseCode}
                  leaseId={leaseId}
                  costCenter={costCenter}
                  desputeStatus={desputeStatus}
                  marqueStatus={marqueStatus}
                  setShow={setDisputShow}
                  setpopupMessageContent={setpopupMessageContent}
                  setpopupalertMessage={setpopupalertMessage}                  
                />
                {/* <AmendLeaseView
                  amendMenus={amendMenus}
                  leaseCode={leaseCode}
                  leaseId={leaseId}
                  costCenter={costCenter}
                  setShow={setShow}
                  setpopupMessageContent={setpopupMessageContent}
                  setpopupalertMessage={setpopupalertMessage}
                /> */}
              </Modal.Body>
            </Modal>

          </div>
        </div>
      </div>
      <Popup open={popupalertMessage} position="top center">
        {(close) => (
          <div>
            {popupMessageContent}
            <a className="close" onClick={redirectToClose}>
              &times;
            </a>
          </div>
        )}
      </Popup>
      <LeaseDetailsPopup
        IsModalOpened={modalIsOpen}
        onCloseModal={handleCloseModal}
        leaseId={leaseId}
        key={popupKey}
      />
    </div>
  );
};
export default LeaseListingTable;
